import { Grid, Typography, withStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import FormDefinition from '../FormDefinition';
import { buildQaNestedFormDefinitionForest } from '../formDefinitionTree.utils';
import { OrderReviewContext } from '../OrderReviewContext';

const styles = theme => ({
  header: {
    fontSize: '1.1rem',
    fontWeight: '700',
    textAlign: 'center',
    color: '#fff',
    backgroundColor: 'var(--jmi-blue)',
    padding: '0.5rem',
    marginBottom: '24px',
  },
  formDefinitionWrapper: {
    padding: '24px 24px 0 24px',
  },
});

export const E2VLevel2 = withStyles(styles)(
  ({ classes, formDefinitions, saveAnswersAsync, removeAnswersAsync, editPropertyCharacteristics }) => {
    const { state } = useContext(OrderReviewContext);
    const filteredFormDefinitions = formDefinitions.filter(
      fd =>
        fd.qaFieldContext !== 'Hidden' &&
        fd.qaFieldContext !== 'Square Feet' &&
        fd.qaFieldContext !== 'Calculate Valuation' &&
        fd.questionCategoryName !== 'Order Info' //&&
        // (fd.answers.some(a => a.images.length === 0) ||
        //   (!fd.answers && state.showAllAnswers) ||
        //   (fd.answers.length === 0 && state.showAllAnswers)),
    );

    const parentFormDefinitions = buildQaNestedFormDefinitionForest(filteredFormDefinitions);

    return (
      <Grid container>
        <Grid item xs={12}>
          <div className={classes.formDefinitionWrapper}>
            {parentFormDefinitions
              .sort((a, b) => a.sequence - b.sequence)
              .map(fd => (
                <FormDefinition
                  key={fd.formDefinitionId}
                  saveAnswers={saveAnswersAsync}
                  removeAnswers={removeAnswersAsync}
                  formDefinition={fd}
                  isReadOnly={editPropertyCharacteristics}
                />
              ))}
          </div>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5" className={classes.header}>
            SQUARE FOOTAGE
          </Typography>
          <div className={classes.formDefinitionWrapper}>
            {formDefinitions
              .filter(fd => fd.qaFieldContext === 'Square Feet')
              .sort((a, b) => a.questionValue.localeCompare(b.questionValue))
              .map(fd => (
                <FormDefinition
                  key={fd.formDefinitionId}
                  saveAnswers={saveAnswersAsync}
                  removeAnswers={removeAnswersAsync}
                  formDefinition={fd}
                  isReadOnly={editPropertyCharacteristics}
                  showAsTableRow
                />
              ))}
          </div>
        </Grid>
      </Grid>
    );
  },
);
